import { createContext, type Key } from 'react';

import type {
    ArgsProps,
    MessageType,
    TypeOpen,
} from 'antd/es/message/interface';

interface AntMessageContextProps {
    open?: (args: ArgsProps) => MessageType;
    destroy?: (key?: Key) => void;
    success?: TypeOpen;
    error?: TypeOpen;
    info?: TypeOpen;
    warning?: TypeOpen;
    loading?: TypeOpen;
}

export const AntMessageContext = createContext<AntMessageContextProps>({});
